import { render, staticRenderFns } from "./PromoPrixTerminal.vue?vue&type=template&id=10056f1a&"
import script from "./PromoPrixTerminal.vue?vue&type=script&lang=js&"
export * from "./PromoPrixTerminal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/0/37545539/myshop/myshop/myshop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('10056f1a')) {
      api.createRecord('10056f1a', component.options)
    } else {
      api.reload('10056f1a', component.options)
    }
    module.hot.accept("./PromoPrixTerminal.vue?vue&type=template&id=10056f1a&", function () {
      api.rerender('10056f1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/main/webapp/WEB-INF/views/fmfmo/common/PromoPrixTerminal.vue"
export default component.exports